function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M380.078,239.844c0.341,6.306.874,14.766-1.562,19.531l-66.016.391c-5.326.8-20,1.695-22.266-.391q1.173-1.366,2.344-2.734L299.609,250l13.672-6.25C331.505,238.127,358.791,239.86,380.078,239.844Zm37.891,0c27.23-.335,59.8-1.348,78.906,8.2l11.719,10.937q-0.195.587-.391,1.172l-0.781,1.172c-17.859-1.36-46.19.26-67.188-2.344-6.013-.745-16.144,2.152-21.484-0.39A155.033,155.033,0,0,1,417.969,239.844Z"
});

var SvgOmEyebrowshapeStraightVector = function SvgOmEyebrowshapeStraightVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "om_eyebrowshape_straight_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOmEyebrowshapeStraightVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/om_eyebrowshape_straight_vector.eb14bb87.svg";
export { ForwardRef as ReactComponent };